import { nullable, partial, string } from 'io-ts/Decoder';

export const Type = partial({
	streetAddress: nullable(string),
	city: nullable(string),
	state: nullable(string),
	postcode: nullable(string),
});
